// extracted by mini-css-extract-plugin
module.exports = {"overflow":"index_overflow__MpXAA","dark_container":"index_dark_container__LgTyV"};